import { conformToMask } from 'vue-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export default {
  name: 'CurrencyMask',
  data() {
    return {
      numberMask: createNumberMask({
        prefix: '',
        suffix: '',
        decimalSymbol: ',',
        allowDecimal: true,
        // requireDecimal: true,
        thousandsSeparatorSymbol: '.',
      }),
      valueMask: '0,00',
    };
  },
  methods: {
    addCurrencyMask(value, $locale = 'pt-BR', $currency = 'BRL') {
      return Number(value).toLocaleString($locale, { style: 'currency', currency: $currency });
    },
    addDecimalMask(value) {
      const val = Number(value).toFixed(2).replace('.', ',');
      const conformedCurrency = conformToMask(
        val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'),
        this.numberMask,
        { guide: false },
      );
      return conformedCurrency.conformedValue;
    },
    removeDecimalMask(value) {
      return parseFloat(value.replace(/\./g, '').replace(',', '.'));
    },
  },
};
